import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { GetUserPermissionList } from 'src/app/state';
import { State } from 'src/app/state/app.state';

import { PageInfo } from '../shared/models/page.info.model';
import { PermissionGridRequestModel } from '../shared/models/permission.grid.request.model';
import { SortInfo } from '../shared/models/sort.info.model';
import { PermissionsServiceService } from '../shared/services/permissions-service.service';

import { ViewMode } from 'src/app/shared/enums/view-mode.enum';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { SortDescriptor } from '@progress/kendo-data-query';
import { PermissionGroup } from 'src/app/master/models/permissionGroup';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AlertDetails } from '../../alerts/shared/models/alerts-grid.model';
import { TranslateService } from '@ngx-translate/core';
import { BusyService } from 'src/app/core/services/busy.service';

@Component({
  selector: 'app-permissions-grid',
  templateUrl: './permissions-grid.component.html',
  styleUrls: ['./permissions-grid.component.scss']
})
export class PermissionsGridComponent implements OnInit {
  public searchText: string = '';
  public gridData: GridDataResult = {data: [], total: 0};
  public pageSize: number = 10;
  public skip: number = 0;
  public showClearButton: boolean = false;
  public permissionGridRequest = new PermissionGridRequestModel();
  addPermissionGroupsEnabled$: Observable<boolean> = new Observable<boolean>();
  editPermissionGroupsEnabled$: Observable<boolean> = new Observable<boolean>();
  public userPermissionList: number[] = [];

  //CX-782
  public showCanDeletePermissionGroupPopup: boolean = false;
  public showCannotDeletePermissionGroupPopup: boolean = false;
  public deletingPermissionGroup: any = null;
  public groupDeletePopupContent: string = '';
  public actionYesLabel: string = '';
  public hasDeleGroupEligibility: boolean = false;
  public permissionGroupDeleteHeader: string = '';

  

  constructor(public permissionService: PermissionsServiceService, private router: Router, private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade, private toastService: ToastService,private translateService: TranslateService,private spinner: BusyService) {
    this.setDefaults();
  }

  ngOnInit(): void {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error('allUserPermissions is undefined!');
      }
      this.userPermissionList = allUserPermissions;
    });
    this.getInitialDataForPermissionGrid();
  }

  public getInitialDataForPermissionGrid() {
    this.searchPermissionGroups();
  }

  private setDefaults() {
    this.permissionGridRequest.PageInfo = new PageInfo();
    this.permissionGridRequest.SortInfo = new SortInfo();
    this.permissionGridRequest.PageInfo.Page = 1;
    this.permissionGridRequest.PageInfo.PageSize = 25;
    this.permissionGridRequest.SortInfo.SortColumn = "PermissionUserGroupName";
    this.permissionGridRequest.SortInfo.sortDirection = "Ascending";
    this.permissionGridRequest.SearchText = '';
  }


  public onPermissionGroupEdit(event: any) {
    this.permissionService.setEdittingPermissionCategory({
      'permissionGroupId': event.permissionUserGroupId,
      'permissionUserGroupName': event.permissionUserGroupName,
      'notificationGroup': event.notificationGroup,
      'viewMode': ViewMode.Edit,
      'canUncheckNotification':event.canUncheckNotification
    });

    this.router.navigate(['/admin/permissions/permission-edit']);
  }

  public onPageChange(event: { skip: number; }) {
    this.permissionGridRequest.PageInfo.Page = (event.skip / this.permissionGridRequest.PageInfo.PageSize) + 1;
    this.searchPermissionGroups();
  }

  public onSortChange(event: SortDescriptor[]) {
    if (event[0].dir == 'asc') {
      this.permissionGridRequest.SortInfo.sortDirection = "Ascending";
    } else {
      this.permissionGridRequest.SortInfo.sortDirection = "Descending";
    }
    this.searchPermissionGroups();
  }

  public clearSarchPermissionGroups() {
    this.setDefaults();
    this.searchText = '';
    this.searchPermissionGroups();
  }

  public searchPermissionGroups() {
    this.permissionGridRequest.SearchText = this.searchText;
    if (this.searchText !== "") {
      this.permissionGridRequest.PageInfo.Page = 1;
    }
    this.permissionService.getDataForPermissionGrid(this.permissionGridRequest).subscribe((gridData) => {
      this.gridData = {
        data: gridData.data,
        total: gridData.totalRowCount
      };
      this.pageSize = gridData.pageSize ?? 1;
      this.skip = (gridData.currentPageNumber - 1) * this.pageSize
    })
  }

  gotoPermissionAdd() {
    this.permissionService.setEdittingPermissionCategory(null);
    this.router.navigate(['/admin/permissions/permission-edit']);
  }

  public onPermissionGroupView(event: any) {
    this.permissionService.setEdittingPermissionCategory({ 'permissionGroupId': event.permissionUserGroupId, 'permissionUserGroupName': event.permissionUserGroupName, 'notificationGroup': event.notificationGroup, 'viewMode': ViewMode.View });
    this.router.navigate(['/admin/permissions/permission-edit']);
  }

  onCloseConfimationPopup() {
    this.showCanDeletePermissionGroupPopup = false;
    this.showCannotDeletePermissionGroupPopup = false;
  }
 
  onDelete(group: any): void
  {
    this.spinner.busy();
    this.deletingPermissionGroup = group;
    this.permissionService.checkDeletionPermissionGroupEligibility(group.permissionUserGroupId, !group.notificationGroup).subscribe({
      next: (response) => {
        this.permissionGroupDeleteHeader = `${this.translateService.instant('_Permisssion_Group_Grid_Modal_Delete_header_Text_')}`
        this.spinner.idle();
        if (response) {
          this.hasDeleGroupEligibility = true;
          this.showCanDeletePermissionGroupPopup = true;
          this.groupDeletePopupContent = `${this.translateService.instant('_Permission_Group_Allow_Delete_Text_')}`
        } else {
          this.hasDeleGroupEligibility = false;
          this.showCannotDeletePermissionGroupPopup = true;
          this.groupDeletePopupContent = `${group.permissionUserGroupName} ${this.translateService.instant('_Permission_Group_Not_Allow_Delete_Text_')}`

        }
      },
      error: () => {
        this.spinner.idle();
        this.toastService.showError(`${this.translateService.instant('_Permission_Permission_Group_Deleted_Failes_Ts_Text_')}`)
      }
    })
  }
      

  performDelete(group: any): void
  {
    this.spinner.busy();
    this.showCanDeletePermissionGroupPopup = false;
    this.showCannotDeletePermissionGroupPopup = false;


    if (this.hasDeleGroupEligibility) {
      this.permissionService.deleteGroup(this.deletingPermissionGroup.permissionUserGroupId, !this.deletingPermissionGroup.notificationGroup).subscribe({
        next: () => {
          this.spinner.idle();

          this.toastService.showSuccess(`${this.translateService.instant('_Permission_Permission_Group_Deleted_Successfully_Ts_Text_')}`)
          this.getInitialDataForPermissionGrid();
          
      },
        error: () => {
          this.toastService.showError(`${this.translateService.instant('_Permission_Permission_Group_Deleted_Failes_Ts_Text_')}`)
          this.spinner.idle();
      }
      });
    }
    }
   
}

